const countryCodes = [
  {
    value: 'CARIB',
    display_name: 'Caribbean',
  },
  {
    value: 'NI',
    display_name: 'Nicaragua',
  },
  {
    value: 'AD',
    display_name: 'Andorra',
  },
  {
    value: 'GQ',
    display_name: 'Equatorial Guinea',
  },
  {
    value: 'SK',
    display_name: 'Slovakia',
  },
  {
    value: 'US-IA',
    display_name: 'United States - Iowa',
  },
  {
    value: 'TL',
    display_name: 'Timor-Leste',
  },
  {
    value: 'US-KY',
    display_name: 'United States - Kentucky',
  },
  {
    value: 'AR',
    display_name: 'Argentina',
  },
  {
    value: 'LY',
    display_name: 'Libya',
  },
  {
    value: 'MN',
    display_name: 'Mongolia',
  },
  {
    value: 'HU',
    display_name: 'Hungary',
  },
  {
    value: 'KE',
    display_name: 'Kenya',
  },
  {
    value: 'RO',
    display_name: 'Romania',
  },
  {
    value: 'KM',
    display_name: 'Comoros',
  },
  {
    value: 'PK',
    display_name: 'Pakistan',
  },
  {
    value: 'KN',
    display_name: 'Saint Kitts and Nevis',
  },
  {
    value: 'US-OR',
    display_name: 'United States - Oregon',
  },
  {
    value: 'UZ',
    display_name: 'Uzbekistan',
  },
  {
    value: 'PF',
    display_name: 'French Polynesia',
  },
  {
    value: 'SA',
    display_name: 'Saudi Arabia',
  },
  {
    value: 'IL',
    display_name: 'Israel',
  },
  {
    value: 'IE',
    display_name: 'Ireland',
  },
  {
    value: 'NU',
    display_name: 'Niue',
  },
  {
    value: 'NAF',
    display_name: 'Northern Africa',
  },
  {
    value: 'OCE',
    display_name: 'Oceania',
  },
  {
    value: 'US-NY',
    display_name: 'United States - New York',
  },
  {
    value: 'MV',
    display_name: 'Maldives',
  },
  {
    value: 'US-FL',
    display_name: 'United States - Florida',
  },
  {
    value: 'GU',
    display_name: 'Guam',
  },
  {
    value: 'ET',
    display_name: 'Ethiopia',
  },
  {
    value: 'EAF',
    display_name: 'Eastern Africa',
  },
  {
    value: 'BW',
    display_name: 'Botswana',
  },
  {
    value: 'TC',
    display_name: 'Turks and Caicos Islands',
  },
  {
    value: 'US-ID',
    display_name: 'United States - Idaho',
  },
  {
    value: 'US-WA',
    display_name: 'United States - Washington',
  },
  {
    value: 'US-TN',
    display_name: 'United States - Tennessee',
  },
  {
    value: 'TM',
    display_name: 'Turkmenistan',
  },
  {
    value: 'MM',
    display_name: 'Myanmar',
  },
  {
    value: 'GI',
    display_name: 'Gibraltar',
  },
  {
    value: 'CS',
    display_name: 'Serbia and Montenegro',
  },
  {
    value: 'US-PA',
    display_name: 'United States - Pennsylvania',
  },
  {
    value: 'PT',
    display_name: 'Portugal',
  },
  {
    value: 'CV',
    display_name: 'Cabo Verde',
  },
  {
    value: 'SAF',
    display_name: 'Southern Africa',
  },
  {
    value: 'WAF',
    display_name: 'Western Africa',
  },
  {
    value: 'SB',
    display_name: 'Solomon Islands',
  },
  {
    value: 'CZ',
    display_name: 'Czech Republic',
  },
  {
    value: 'KP',
    display_name: "Democratic People's Republic of Korea",
  },
  {
    value: 'US-TX',
    display_name: 'United States - Texas',
  },
  {
    value: 'US-ND',
    display_name: 'United States - North Dakota',
  },
  {
    value: 'IS',
    display_name: 'Iceland',
  },
  {
    value: 'SD',
    display_name: 'Sudan',
  },
  {
    value: 'US-KS',
    display_name: 'United States - Kansas',
  },
  {
    value: 'VE',
    display_name: 'Venezuela (Bolivarian Republic of)',
  },
  {
    value: 'MK',
    display_name: 'The former Yugoslav Republic of Macedonia',
  },
  {
    value: 'TO',
    display_name: 'Tonga',
  },
  {
    value: 'VA',
    display_name: 'Holy See',
  },
  {
    value: 'SC',
    display_name: 'Seychelles',
  },
  {
    value: 'AW',
    display_name: 'Aruba',
  },
  {
    value: 'TG',
    display_name: 'Togo',
  },
  {
    value: 'BA',
    display_name: 'Bosnia and Herzegovina',
  },
  {
    value: 'WS',
    display_name: 'Samoa',
  },
  {
    value: 'ID',
    display_name: 'Indonesia',
  },
  {
    value: 'NER',
    display_name: 'Northern Europe',
  },
  {
    value: 'PM',
    display_name: 'Saint Pierre and Miquelon',
  },
  {
    value: 'VU',
    display_name: 'Vanuatu',
  },
  {
    value: 'VN',
    display_name: 'Viet Nam',
  },
  {
    value: 'RAM',
    display_name: 'Americas',
  },
  {
    value: 'US-OK',
    display_name: 'United States - Oklahoma',
  },
  {
    value: 'CF',
    display_name: 'Central African Republic',
  },
  {
    value: 'IR',
    display_name: 'Iran (Islamic Republic of)',
  },
  {
    value: 'MX',
    display_name: 'Mexico',
  },
  {
    value: 'MQ',
    display_name: 'Martinique',
  },
  {
    value: 'SL',
    display_name: 'Sierra Leone',
  },
  {
    value: 'MU',
    display_name: 'Mauritius',
  },
  {
    value: 'US-NE',
    display_name: 'United States - Nebraska',
  },
  {
    value: 'PW',
    display_name: 'Palau',
  },
  {
    value: 'GL',
    display_name: 'Greenland',
  },
  {
    value: 'MS',
    display_name: 'Montserrat',
  },
  {
    value: 'GH',
    display_name: 'Ghana',
  },
  {
    value: 'NC',
    display_name: 'New Caledonia',
  },
  {
    value: 'PA',
    display_name: 'Panama',
  },
  {
    value: 'US-IN',
    display_name: 'United States - Indiana',
  },
  {
    value: 'AG',
    display_name: 'Antigua and Barbuda',
  },
  {
    value: 'GB',
    display_name: 'United Kingdom',
  },
  {
    value: 'EC',
    display_name: 'Ecuador',
  },
  {
    value: 'MC',
    display_name: 'Monaco',
  },
  {
    value: 'US-VA',
    display_name: 'United States - Virginia',
  },
  {
    value: 'NG',
    display_name: 'Nigeria',
  },
  {
    value: 'AT',
    display_name: 'Austria',
  },
  {
    value: 'SJ',
    display_name: 'Svalbard and Jan Mayen Islands',
  },
  {
    value: 'US-CA',
    display_name: 'United States - California',
  },
  {
    value: 'DJ',
    display_name: 'Djibouti',
  },
  {
    value: 'NR',
    display_name: 'Nauru',
  },
  {
    value: 'US-AZ',
    display_name: 'United States - Arizona',
  },
  {
    value: 'MZ',
    display_name: 'Mozambique',
  },
  {
    value: 'HK',
    display_name: 'China, Hong Kong SAR',
  },
  {
    value: 'JP',
    display_name: 'Japan',
  },
  {
    value: 'MY',
    display_name: 'Malaysia',
  },
  {
    value: 'US',
    display_name: 'United States of America',
  },
  {
    value: 'US-MT',
    display_name: 'United States - Montana',
  },
  {
    value: 'US-MS',
    display_name: 'United States - Mississippi',
  },
  {
    value: 'DM',
    display_name: 'Dominica',
  },
  {
    value: 'RAS',
    display_name: 'Asia',
  },
  {
    value: 'US-MD',
    display_name: 'United States - Maryland',
  },
  {
    value: 'US-CO',
    display_name: 'United States - Colorado',
  },
  {
    value: 'OM',
    display_name: 'Oman',
  },
  {
    value: 'UG',
    display_name: 'Uganda',
  },
  {
    value: 'CH',
    display_name: 'Switzerland',
  },
  {
    value: 'RNA',
    display_name: 'North America',
  },
  {
    value: 'GP',
    display_name: 'Guadeloupe',
  },
  {
    value: 'VG',
    display_name: 'British Virgin Islands',
  },
  {
    value: 'NP',
    display_name: 'Nepal',
  },
  {
    value: 'LB',
    display_name: 'Lebanon',
  },
  {
    value: 'LS',
    display_name: 'Lesotho',
  },
  {
    value: 'JM',
    display_name: 'Jamaica',
  },
  {
    value: 'QA',
    display_name: 'Qatar',
  },
  {
    value: 'LK',
    display_name: 'Sri Lanka',
  },
  {
    value: 'CR',
    display_name: 'Costa Rica',
  },
  {
    value: 'BY',
    display_name: 'Belarus',
  },
  {
    value: 'PN',
    display_name: 'Pitcairn Islands',
  },
  {
    value: 'UA',
    display_name: 'Ukraine',
  },
  {
    value: 'KZ',
    display_name: 'Kazakhstan',
  },
  {
    value: 'SG',
    display_name: 'Singapore',
  },
  {
    value: 'RE',
    display_name: 'Réunion',
  },
  {
    value: 'CA',
    display_name: 'Canada',
  },
  {
    value: 'GR',
    display_name: 'Greece',
  },
  {
    value: 'BR',
    display_name: 'Brazil',
  },
  {
    value: 'TK',
    display_name: 'Tokelau (Associate Member)',
  },
  {
    value: 'MH',
    display_name: 'Marshall Islands',
  },
  {
    value: 'BI',
    display_name: 'Burundi',
  },
  {
    value: 'KG',
    display_name: 'Kyrgyzstan',
  },
  {
    value: 'US-NC',
    display_name: 'United States - North Carolina',
  },
  {
    value: 'ZA',
    display_name: 'South Africa',
  },
  {
    value: 'EG',
    display_name: 'Egypt',
  },
  {
    value: 'MW',
    display_name: 'Malawi',
  },
  {
    value: 'GD',
    display_name: 'Grenada',
  },
  {
    value: 'CO',
    display_name: 'Colombia',
  },
  {
    value: 'US-GA',
    display_name: 'United States - Georgia',
  },
  {
    value: 'JO',
    display_name: 'Jordan',
  },
  {
    value: 'SY',
    display_name: 'Syrian Arab Republic',
  },
  {
    value: 'MELAN',
    display_name: 'Melanesia',
  },
  {
    value: 'GN',
    display_name: 'Guinea',
  },
  {
    value: 'US-MN',
    display_name: 'United States - Minnesota',
  },
  {
    value: 'AL',
    display_name: 'Albania',
  },
  {
    value: 'TV',
    display_name: 'Tuvalu',
  },
  {
    value: 'DE',
    display_name: 'Germany',
  },
  {
    value: 'GW',
    display_name: 'Guinea-Bissau',
  },
  {
    value: 'SAS',
    display_name: 'Southern Asia',
  },
  {
    value: 'BM',
    display_name: 'Bermuda',
  },
  {
    value: 'GA',
    display_name: 'Gabon',
  },
  {
    value: 'US-SC',
    display_name: 'United States - South Carolina',
  },
  {
    value: 'HT',
    display_name: 'Haiti',
  },
  {
    value: 'ZW',
    display_name: 'Zimbabwe',
  },
  {
    value: 'NA',
    display_name: 'Namibia',
  },
  {
    value: 'CN',
    display_name: 'China',
  },
  {
    value: 'BD',
    display_name: 'Bangladesh',
  },
  {
    value: 'MD',
    display_name: 'Republic of Moldova',
  },
  {
    value: 'HR',
    display_name: 'Croatia',
  },
  {
    value: 'AI',
    display_name: 'Anguilla',
  },
  {
    value: 'PR',
    display_name: 'Puerto Rico',
  },
  {
    value: 'AE',
    display_name: 'United Arab Emirates',
  },
  {
    value: 'WAS',
    display_name: 'Western Asia',
  },
  {
    value: 'ME',
    display_name: 'Montenegro',
  },
  {
    value: 'GE',
    display_name: 'Georgia',
  },
  {
    value: 'BG',
    display_name: 'Bulgaria',
  },
  {
    value: 'NZ',
    display_name: 'New Zealand',
  },
  {
    value: 'NF',
    display_name: 'Norfolk Island',
  },
  {
    value: 'BE',
    display_name: 'Belgium',
  },
  {
    value: 'TJ',
    display_name: 'Tajikistan',
  },
  {
    value: 'LR',
    display_name: 'Liberia',
  },
  {
    value: 'AZ',
    display_name: 'Azerbaijan',
  },
  {
    value: 'MA',
    display_name: 'Morocco',
  },
  {
    value: 'BT',
    display_name: 'Bhutan',
  },
  {
    value: 'RCA',
    display_name: 'Central America',
  },
  {
    value: 'VI',
    display_name: 'United States Virgin Islands',
  },
  {
    value: 'KW',
    display_name: 'Kuwait',
  },
  {
    value: 'IM',
    display_name: 'Isle of Man',
  },
  {
    value: 'CAS',
    display_name: 'Central Asia',
  },
  {
    value: 'SR',
    display_name: 'Suriname',
  },
  {
    value: 'AU',
    display_name: 'Australia',
  },
  {
    value: 'SEAS',
    display_name: 'South-eastern Asia',
  },
  {
    value: 'FM',
    display_name: 'Micronesia (Federated States of)',
  },
  {
    value: 'NE',
    display_name: 'Niger',
  },
  {
    value: 'BN',
    display_name: 'Brunei Darussalam',
  },
  {
    value: 'SER',
    display_name: 'Southern Europe',
  },
  {
    value: 'EE',
    display_name: 'Estonia',
  },
  {
    value: 'IQ',
    display_name: 'Iraq',
  },
  {
    value: 'HN',
    display_name: 'Honduras',
  },
  {
    value: 'MT',
    display_name: 'Malta',
  },
  {
    value: 'YE',
    display_name: 'Yemen',
  },
  {
    value: 'DK',
    display_name: 'Denmark',
  },
  {
    value: 'EAS',
    display_name: 'Eastern Asia',
  },
  {
    value: 'LV',
    display_name: 'Latvia',
  },
  {
    value: 'VC',
    display_name: 'Saint Vincent and the Grenadines',
  },
  {
    value: 'DZ',
    display_name: 'Algeria',
  },
  {
    value: 'SN',
    display_name: 'Senegal',
  },
  {
    value: 'BF',
    display_name: 'Burkina Faso',
  },
  {
    value: 'RSA',
    display_name: 'South America',
  },
  {
    value: 'BS',
    display_name: 'Bahamas',
  },
  {
    value: 'SE',
    display_name: 'Sweden',
  },
  {
    value: 'PH',
    display_name: 'Philippines',
  },
  {
    value: 'AU-NZ',
    display_name: 'Australia and New Zealand',
  },
  {
    value: 'TN',
    display_name: 'Tunisia',
  },
  {
    value: 'BJ',
    display_name: 'Benin',
  },
  {
    value: 'TT',
    display_name: 'Trinidad and Tobago',
  },
  {
    value: 'FO',
    display_name: 'Faroe Islands (Associate Member)',
  },
  {
    value: 'KH',
    display_name: 'Cambodia',
  },
  {
    value: 'FK',
    display_name: 'Falkland Islands (Malvinas)',
  },
  {
    value: 'US-WI',
    display_name: 'United States - Wisconsin',
  },
  {
    value: 'RER',
    display_name: 'Europe',
  },
  {
    value: 'US-AR',
    display_name: 'United States - Arkansas',
  },
  {
    value: 'CI',
    display_name: "Cote d'Ivoire",
  },
  {
    value: 'BB',
    display_name: 'Barbados',
  },
  {
    value: 'LU',
    display_name: 'Luxembourg',
  },
  {
    value: 'UY',
    display_name: 'Uruguay',
  },
  {
    value: 'DO',
    display_name: 'Dominican Republic',
  },
  {
    value: 'LA',
    display_name: "Lao People's Democratic Republic",
  },
  {
    value: 'MR',
    display_name: 'Mauritania',
  },
  {
    value: 'WER',
    display_name: 'Western Europe',
  },
  {
    value: 'IT',
    display_name: 'Italy',
  },
  {
    value: 'EER',
    display_name: 'Eastern Europe',
  },
  {
    value: 'CU',
    display_name: 'Cuba',
  },
  {
    value: 'BZ',
    display_name: 'Belize',
  },
  {
    value: 'GT',
    display_name: 'Guatemala',
  },
  {
    value: 'AF',
    display_name: 'Afghanistan',
  },
  {
    value: 'SV',
    display_name: 'El Salvador',
  },
  {
    value: 'ML',
    display_name: 'Mali',
  },
  {
    value: 'BH',
    display_name: 'Bahrain',
  },
  {
    value: 'CY',
    display_name: 'Cyprus',
  },
  {
    value: 'SS',
    display_name: 'South Sudan',
  },
  {
    value: 'LC',
    display_name: 'Saint Lucia',
  },
  {
    value: 'US-IL',
    display_name: 'United States - Illinois',
  },
  {
    value: 'LI',
    display_name: 'Liechtenstein',
  },
  {
    value: 'TW',
    display_name: 'China, Taiwan Province of',
  },
  {
    value: 'WF',
    display_name: 'Wallis and Futuna Islands',
  },
  {
    value: 'MP',
    display_name: 'Northern Mariana Islands',
  },
  {
    value: 'AO',
    display_name: 'Angola',
  },
  {
    value: 'US-DE',
    display_name: 'United States - Delaware',
  },
  {
    value: 'MAF',
    display_name: 'Middle Africa',
  },
  {
    value: 'GM',
    display_name: 'Gambia',
  },
  {
    value: 'ER',
    display_name: 'Eritrea',
  },
  {
    value: 'CK',
    display_name: 'Cook Islands',
  },
  {
    value: 'ES',
    display_name: 'Spain',
  },
  {
    value: 'SH',
    display_name: 'Saint Helena, Ascension and Tristan da Cunha',
  },
  {
    value: 'MO',
    display_name: 'China, Macao SAR',
  },
  {
    value: 'KY',
    display_name: 'Cayman Islands',
  },
  {
    value: 'TZ',
    display_name: 'United Republic of Tanzania',
  },
  {
    value: 'AN',
    display_name: 'Netherlands Antilles (former)',
  },
  {
    value: 'CL',
    display_name: 'Chile',
  },
  {
    value: 'GY',
    display_name: 'Guyana',
  },
  {
    value: 'BO',
    display_name: 'Bolivia (Plurinational State of)',
  },
  {
    value: 'MG',
    display_name: 'Madagascar',
  },
  {
    value: 'CD',
    display_name: 'Democratic Republic of the Congo',
  },
  {
    value: 'PL',
    display_name: 'Poland',
  },
  {
    value: 'SZ',
    display_name: 'Swaziland',
  },
  {
    value: 'NO',
    display_name: 'Norway',
  },
  {
    value: 'PG',
    display_name: 'Papua New Guinea',
  },
  {
    value: 'SM',
    display_name: 'San Marino',
  },
  {
    value: 'KI',
    display_name: 'Kiribati',
  },
  {
    value: 'RS',
    display_name: 'Serbia',
  },
  {
    value: 'YT',
    display_name: 'Mayotte',
  },
  {
    value: 'US-MI',
    display_name: 'United States - Michigan',
  },
  {
    value: 'SI',
    display_name: 'Slovenia',
  },
  {
    value: 'US-SD',
    display_name: 'United States - South Dakota',
  },
  {
    value: 'RU',
    display_name: 'Russian Federation',
  },
  {
    value: 'NaN',
    display_name: 'Unknown',
  },
  {
    value: 'POLY',
    display_name: 'Polynesia',
  },
  {
    value: 'ZM',
    display_name: 'Zambia',
  },
  {
    value: 'KR',
    display_name: 'Republic of Korea',
  },
  {
    value: 'IN',
    display_name: 'India',
  },
  {
    value: 'LT',
    display_name: 'Lithuania',
  },
  {
    value: 'US-AL',
    display_name: 'United States - Alabama',
  },
  {
    value: 'GF',
    display_name: 'French Guiana',
  },
  {
    value: 'SO',
    display_name: 'Somalia',
  },
  {
    value: 'ST',
    display_name: 'Sao Tome and Principe',
  },
  {
    value: 'US-LA',
    display_name: 'United States - Louisiana',
  },
  {
    value: 'AM',
    display_name: 'Armenia',
  },
  {
    value: 'AS',
    display_name: 'American Samoa',
  },
  {
    value: 'PE',
    display_name: 'Peru',
  },
  {
    value: 'FJ',
    display_name: 'Fiji',
  },
  {
    value: 'NL',
    display_name: 'Netherlands',
  },
  {
    value: 'CM',
    display_name: 'Cameroon',
  },
  {
    value: 'RW',
    display_name: 'Rwanda',
  },
  {
    value: 'TH',
    display_name: 'Thailand',
  },
  {
    value: 'FR',
    display_name: 'France',
  },
  {
    value: 'PY',
    display_name: 'Paraguay',
  },
  {
    value: 'FI',
    display_name: 'Finland',
  },
  {
    value: 'US-MO',
    display_name: 'United States - Missouri',
  },
  {
    value: 'MICRO',
    display_name: 'Micronesia',
  },
  {
    value: 'RAF',
    display_name: 'Africa',
  },
  {
    value: 'CG',
    display_name: 'Congo',
  },
  {
    value: 'TR',
    display_name: 'Turkey',
  },
  {
    value: 'US-OH',
    display_name: 'United States - Ohio',
  },
  {
    value: 'TD',
    display_name: 'Chad',
  },
  {
    value: 'GLO',
    display_name: 'Global',
  },
  {
    value: 'NaN',
    display_name: 'Unknown',
  },
];

export default countryCodes;
